import { __decorate, __metadata, __param } from "tslib";
import { fetchManyDocuments } from '@gn-audio/core/api/knowledge-base';
import { fetchGroups } from '@gn-audio/core/api/product-catalogue';
import { Component, Inject, Input } from 'angular-ts-decorators';
import template from './documents-overview.component.html';
var DocumentsOverviewComponent = (function () {
    function DocumentsOverviewComponent($q) {
        this.$q = $q;
        this.documentItems = [];
    }
    DocumentsOverviewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.selectedLanguage =
            this.languages.filter(function (l) { return l.languageCode.toLowerCase() === _this.defaultLanguage; })[0] || this.languages[0];
        this.loadDocuments();
    };
    DocumentsOverviewComponent.prototype.onLanguageChanged = function (language) {
        this.selectedLanguage = language;
        this.loadDocuments();
    };
    DocumentsOverviewComponent.prototype.languageIsEnglish = function (language) {
        return language.languageCode.indexOf('en-') > -1;
    };
    DocumentsOverviewComponent.prototype.loadDocuments = function () {
        var _this = this;
        this.itemsLoading = true;
        this.$q.when(fetchManyDocuments(this.groupIds, true))
            .then(function (documents) {
            var existingGroupIds = [];
            Object.keys(documents).forEach(function (documentGroupId) {
                if (documents[documentGroupId].length === 0) {
                    return;
                }
                existingGroupIds.push(Number(documentGroupId));
            });
            if (existingGroupIds.length === 0) {
                _this.documentItems.length = 0;
            }
            else {
                _this.$q.when(fetchGroups(existingGroupIds))
                    .then(function (groups) {
                    _this.documentItems = (groups || []).map(function (g) { return g; });
                    for (var _i = 0, _a = _this.documentItems; _i < _a.length; _i++) {
                        var item = _a[_i];
                        item.documents = documents[String(item.groupId)] || [];
                    }
                    _this.itemsLoading = false;
                });
            }
        });
    };
    DocumentsOverviewComponent.$inject = ['$q'];
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], DocumentsOverviewComponent.prototype, "defaultLanguage", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], DocumentsOverviewComponent.prototype, "groupIds", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], DocumentsOverviewComponent.prototype, "languages", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], DocumentsOverviewComponent.prototype, "warningAndDeclarationsUrl", void 0);
    DocumentsOverviewComponent = __decorate([
        Component({
            selector: 'documentsOverview',
            template: template,
        }),
        __param(0, Inject('$q')),
        __metadata("design:paramtypes", [Function])
    ], DocumentsOverviewComponent);
    return DocumentsOverviewComponent;
}());
export { DocumentsOverviewComponent };
